module.exports = function getResource(label) {
    let resources = {
        emailLabel: 'Courriel',
        nameLabel: 'Nom',
        editLink: 'Modifier'
    };

    return resources[label];
};
